import React from 'react';
import { Link } from 'react-router-dom';
import { Quote, MapPin } from 'lucide-react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';

const NewsSection = ({ latestPosts, testimonials = [], t, user }) => {
  if (!testimonials.length) return null;

  return (
    <section className={`animate-fade-in-up ${user ? 'lg:hidden' : ''}`} data-testid="news-section">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-heading font-bold text-lg text-primary flex items-center gap-2">
          <Quote className="w-5 h-5 text-hoi-coral" aria-hidden="true" /> {t('home.latest_news')}
        </h3>
        <Link to="/verhalen" className="text-sm text-primary font-medium hover:underline flex items-center gap-1">
          {t('home.all_news')} <span aria-hidden="true">&rarr;</span>
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {testimonials.slice(0, 3).map((story) => (
          <Link key={story.id} to={`/verhaal/${story.slug || story.id}`}>
            <Card className="rounded-2xl overflow-hidden border-2 border-slate-100 hover:border-hoi-coral/20 hover:shadow-hover transition-all h-full">
              <div className="w-full h-36 bg-gradient-to-br from-slate-100 to-slate-200 overflow-hidden">
                {story.image_url ? (
                  <img src={story.image_url} alt={story.person_name} className="w-full h-36 object-cover" loading="lazy" />
                ) : (
                  <div className="w-full h-36 flex items-center justify-center bg-hoi-coral/5">
                    <Quote className="w-8 h-8 text-hoi-coral/30" />
                  </div>
                )}
              </div>
              <div className="p-3 space-y-1.5">
                <Badge className="text-xs bg-hoi-coral/10 text-hoi-coral border-0">{t('inspiratie.badge_verhaal')}</Badge>
                <h4 className="font-heading font-semibold text-sm text-primary line-clamp-2">{story.title}</h4>
                <p className="text-xs text-muted-foreground flex items-center gap-1">
                  {story.person_name} ({story.person_age})
                  {story.person_wijk && <><MapPin className="w-3 h-3 ml-1" />{story.person_wijk}</>}
                </p>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default NewsSection;
